import { generateRoute } from '@/assets/common/menu.js'
import { getMenu}  from '@/assets/api/common.js'
// import { menuList} from '@/assets/mock.js'
import ss from '@/assets/common/ss'

const main = {
	state: {
    staticRoutes: [ // 静态路由
      {
        path: '/login',
        component: () => import('@/view/login'),
        name: 'login',
        meta: { title: '登录' }
      },

      {
        path: '/example',
        component: () => import('@/view/example'),
        name: 'example',
        meta: { title: '组件Demo' }
      },
      {
        path: '/dealCheck/notice',
        component: () => import('@/view/dealCheck/notice'),
        name: 'notice',
        meta: { title: '提醒与通知' }
      },
      {
        path: '/open-acct/acct-type',
        component: () => import('@/view/open-acct/acct-type'),
        name: 'acctType',
        meta: { title: '选择开户类型' }
      },
      {
        path: '/open-acct/org/info-verif',
        component: () => import('@/view/open-acct/org/info-verif'),
        name: 'orgInfoverif',
        meta: { title: '机构开户-机构信息' }
      },
      {
        path: '/open-acct/org/details',
        component: () => import('@/view/open-acct/org/details'),
        name: 'orgDetails',
        meta: { title: '机构开户-详细资料' }
      },
      {
        path: '/open-acct/org/risk',
        component: () => import('@/view/open-acct/org/risk'),
        name: 'orgRisk',
        meta: { title: '机构开户-风险测评' }
      },
      {
        path: '/open-acct/org/set-pswd',
        component: () => import('@/view/open-acct/org/set-pswd'),
        name: 'orgSetPswd',
        meta: { title: '机构开户-设置密码' }
      },
      {
        path: '/open-acct/org/results',
        component: () => import('@/view/open-acct/org/results'),
        name: 'orgRel',
        meta: { title: '机构开户-开户结果' }
      },
      {
        path: '/open-acct/product/info',
        component: () => import('@/view/open-acct/product/info'),
        name: 'productInfo',
        meta: { title: '产品开户-产品信息' }
      },
      {
        path: '/open-acct/product/details',
        component: () => import('@/view/open-acct/product/details'),
        name: 'productDetails',
        meta: { title: '产品开户-详细资料' }
      },
      {
        path: '/open-acct/product/add-product-details',
        component: () => import('@/view/open-acct/product/add-product-details'),
        name: 'addProductDetails',
        meta: { title: '产品开户-详细资料' }
      },
      {
        path: '/open-acct/product/risk',
        component: () => import('@/view/open-acct/product/risk'),
        name: 'productRisk',
        meta: { title: '产品开户-风险测评' }
      },
      {
        path: '/open-acct/product/set-pswd',
        component: () => import('@/view/open-acct/product/set-pswd'),
        name: 'productSetPswd',
        meta: { title: '产品开户-设置密码' }
      },
      {
        path: '/open-acct/product/results',
        component: () => import('@/view/open-acct/product/results'),
        name: 'productRel',
        meta: { title: '产品开户-开户结果' }
      },
      {
        path: '/my-acct/rist-expire',
        component: () => import('@/view/my-acct/rist-expire'),
        name: 'ristExpire',
        meta: { title: '风测过期' }
      }
    ],
    routesPathList: [
      '/login', '/example','/dealCheck/notice','/open-acct/acct-type', '/open-acct/org/info-verif',
      '/open-acct/org/details', '/open-acct/org/risk', '/open-acct/org/set-pswd',
      '/open-acct/org/results', '/open-acct/product/info', '/open-acct/product/details','/open-acct/product/add-product-details',
      '/open-acct/product/risk', '/open-acct/product/set-pswd', '/open-acct/product/results', '/my-acct/rist-expire'
    ],
    routesMap: {},
    trendsRoutes: [], // 动态路由
    menuList: [],
		activeMenu: '',
    openOrgSteps: [
      {
        stepId: 1,
        stepName: '机构信息',
        stepDesc: '检验机构信息'
      },
      {
        stepId: 2,
        stepName: '详细资料',
        stepDesc: '填写详细资料'
      },
      {
        stepId: 3,
        stepName: '风险测评',
        stepDesc: '填写问卷信息'
      },
      {
        stepId: 4,
        stepName: '设置密码',
        stepDesc: '设置密码'
      },
      {
        stepId: 5,
        stepName: '开户结果',
        stepDesc: '确认结果'
      }
    ],
    openProductSteps: [
      {
        stepId: 1,
        stepName: '产品信息',
        stepDesc: '填写产品信息'
      },
      {
        stepId: 2,
        stepName: '详细资料',
        stepDesc: '填写详细资料'
      },
      {
        stepId: 3,
        stepName: '设置密码',
        stepDesc: '设置密码'
      },
      {
        stepId: 4,
        stepName: '开户结果',
        stepDesc: '确认结果'
      }
    ],
    addOpenProductSteps: [ // 增开产品户步骤
      {
        stepId: 1,
        stepName: '产品信息',
        stepDesc: '填写产品信息'
      },
      {
        stepId: 2,
        stepName: '详细资料',
        stepDesc: '填写详细资料'
      },
      {
        stepId: 3,
        stepName: '确认密码',
        stepDesc: '确认密码'
      },
      {
        stepId: 4,
        stepName: '开户结果',
        stepDesc: '确认结果'
      }
    ],
    dicts: {
      prCy: []
    }
	},
 	mutations: {
    setTrendsRoutes(state, list) {
      state.trendsRoutes = generateRoute(list);
    },
    setRoutesMap(state, obj) {
      state.routesMap = obj;
    },
    setRoutesPathList(state, list) {
      state.routesPathList = list;
    },
    setMenuList(state, list) {
      state.menuList = list;
    },
    activeMenuChange(state, str) {
      state.activeMenu = str;
    },
    setPrCyDict(state, list) {
      state.dicts.prCy = list;
    },
    clearBuyList(state, params) {
      ss.removeItem('buyRow')
    },
  },
  actions: {
    async getMenuList ({commit}) {
      let menuData = await getMenu();
      commit('setMenuList', menuData);
      commit('setTrendsRoutes', menuData);
    },
    loginOut({commit}) {
      let routesPathList = [
        '/login', '/example','/dealCheck/notice', '/open-acct/acct-type', '/open-acct/org/info-verif',
        '/open-acct/org/details', '/open-acct/org/risk', '/open-acct/org/set-pswd',
        '/open-acct/org/results', '/open-acct/product/info', '/open-acct/product/details','/open-acct/product/add-product-details',
        '/open-acct/product/risk', '/open-acct/product/set-pswd', '/open-acct/product/results', '/my-acct/rist-expire'
      ];
      commit('setRoutesPathList', routesPathList);
    }
  }
}

export default main



// WEBPACK FOOTER //
// ./src/store/modules/main.js